import { useMutation } from '@/hooks/mutationWithSnackbar';

import { graphql } from '@/gql';

import { addNewFileToCache } from '../utils/fileUpdateFunctions';

const CREATE_FOLDER_MUTATION = graphql(`
  mutation CreateFolder($data: CreateFolderInput) {
    createFolder(params: $data) {
      file {
        ...fileFields
      }
    }
  }
`);

export const useCreateFolder = (rootOwnerId: string) => {
  const createFolderMutation = useMutation(CREATE_FOLDER_MUTATION, {
    update(cache, { data }) {
      const file = data?.createFolder?.file;

      addNewFileToCache(cache, file, rootOwnerId);
    },
  });

  return createFolderMutation;
};
